import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { AbstractRandom2p16g6waffir7 as AbstractRandom } from './AbstractRandom.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function defaultCryptographyRandom() {
  return WebCryptoCryptographyRandom_getInstance();
}
function fillBytes($this, jsArray) {
  var size = jsArray.length;
  if (size <= 65536) {
    $this.crypto_1.getRandomValues(jsArray);
  } else {
    var filled = 0;
    do {
      // Inline function 'kotlin.comparisons.minOf' call
      var b = size - filled | 0;
      var chunkSize = Math.min(65536, b);
      $this.crypto_1.getRandomValues(jsArray.subarray(filled, filled + chunkSize | 0));
      filled = filled + chunkSize | 0;
    }
     while (filled < size);
  }
}
var WebCryptoCryptographyRandomClass;
function WebCryptoCryptographyRandom() {
  if (WebCryptoCryptographyRandomClass === VOID) {
    class $ extends AbstractRandom() {
      constructor() {
        return new.target.new_dev_whyoleg_cryptography_random_WebCryptoCryptographyRandom_kq9beu_k$();
      }
      static new_dev_whyoleg_cryptography_random_WebCryptoCryptographyRandom_kq9beu_k$() {
        WebCryptoCryptographyRandom_instance = null;
        var $this = this.new_dev_whyoleg_cryptography_random_AbstractRandom_15v2cv_k$();
        WebCryptoCryptographyRandom_instance = $this;
        $this.MAX_ARRAY_SIZE_1 = 65536;
        $this.crypto_1 = getCrypto();
        return $this;
      }
      fillBytes_4b4b08_k$(array) {
        // Inline function 'dev.whyoleg.cryptography.random.useAsInt8Array' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        fillBytes(this, array);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'WebCryptoCryptographyRandom');
    WebCryptoCryptographyRandomClass = $;
  }
  return WebCryptoCryptographyRandomClass;
}
var WebCryptoCryptographyRandom_instance;
function WebCryptoCryptographyRandom_getInstance() {
  if (WebCryptoCryptographyRandom_instance === VOID)
    WebCryptoCryptographyRandom().new_dev_whyoleg_cryptography_random_WebCryptoCryptographyRandom_kq9beu_k$();
  return WebCryptoCryptographyRandom_instance;
}
function getCrypto() {
  return globalThis ? globalThis.crypto : window.crypto || window.msCrypto;
}
//region block: exports
export {
  defaultCryptographyRandom as defaultCryptographyRandom3hu9p6ooea5au,
};
//endregion

//# sourceMappingURL=CryptographyRandom.web.mjs.map
